import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';


@Component({
  selector: 'cell-renderer',
  standalone: true,
  imports: [NzIconModule, NzSpinModule, CommonModule],
  templateUrl: './cell-renderer.component.html',
  styleUrl: './cell-renderer.component.scss'
})
export class CellRendererComponent implements ICellRendererAngularComp{
  params: any;
  value!: string;

  agInit(params: any): void {
    this.params = params;
    this.value = params.value;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.value = params.value;
    return true;
  }

  startEdit() {
    if (this.saving) return;
    this.params.api.startEditingCell({
      rowIndex: this.params.rowIndex,
      colKey: 'partner_name'
    });
  }

  get saving(): boolean {
    return this.params.data?._saving === true;
  }

}
